<template>
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">

        <div v-show="photosArray.length > 0" v-for="(item, index) in photosArray" class="wrap">
            <div>

                <span v-show="false">{{getImgUrl(item,item.photo_id)}}</span>
                <img :src="showPhoto(item.photoUrl)" width="120px" height="120px"
                     style="margin-top: 10px;float: left;margin-left: 5px;margin-bottom: 5px"
                     @click="dialogVisibles(item.bigPhotoUrl)"/>

                <img :src="Delete_icon" width="20px" height="20px"
                     style="float: left;margin-left: -10px"
                     @click="deletePhotos(item.photo_id)" v-show="isAdmin"/>

                <p v-if="item.title" class="desc">{{item.title}}</p>
                <p v-else style="color: #ffffff;text-align: center;">无</p>

            </div>
        </div>

        <div class="wrap" v-show="isAdmin">
            <img :src="Add_picture" width="120px" height="120px"
                 style="margin-top: 10px;margin-bottom: 3px"
                 @click="showDialogVisiblesPhoto()"/>

            <p style="font-size: 14px;width: 120px;text-align: center;margin: 0;color: #ffffff">新增</p>
        </div>
        <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogSrc" alt="">
        </el-dialog>

        <el-dialog
                :visible.sync="dialogVisiblePhoto"
                width="50%"
                :show-close="false"
                :before-close="handleClose"

                style="vertical-align: center;: #FFF9F3">
            <div style="margin-top: -40px">

                <el-row style="border-bottom: 2px dotted #e7eaec;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-weight: bold;padding-top: 8px;font-size: 16px">
                            <span>上传照片</span>
                        </div>
                    </el-col>

                    <el-col :span="12" style="margin-bottom: 10px">
                        <div align="right">
                            <el-button type="danger" size="small" @click.stop="handleClose">
                                关闭
                            </el-button>
                            <el-button type="primary" size="small" @click.stop="submitFile">
                                上传
                            </el-button>
                        </div>
                    </el-col>
                </el-row>


                <div style="margin-top: 20px;">

                    <el-form ref="form" label-width="100px">
                        <el-form-item label="标题">
                            <el-input v-model="title" placeholder="请输入标题"></el-input>
                        </el-form-item>

                        <el-form-item label="上传图片" class="a_upload_file">

                            <!--<el-upload-->
                            <!--ref="uploadFile"-->
                            <!--class="avatar-uploader"-->
                            <!--:http-request="uploadFun"-->
                            <!--:auto-upload="false"-->
                            <!--action="https://api.retailstore365.com:15041/uploadphoto"-->
                            <!--:on-change="handChange"-->
                            <!--:on-remove="handleRemove"-->
                            <!--:before-remove="beforeRemove"-->
                            <!--:before-upload="beforePhotoUpload"-->
                            <!--:on-exceed="handleExceed"-->
                            <!--:show-file-list="false">-->
                            <!--<img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar">-->
                            <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
                            <!--</el-upload>-->

                            <!--<Upload desc="你可以上传jpg或png格式的文件, 图片建议尺寸至少为128x128, 文件大小不能超过10M。" @uploadSuccess="showPhoto" :img="Delete_icon" :isManager="true"/>-->

                            <div :class="$style.container" class="upload">
                                <el-upload
                                        ref="uploadFile"
                                        class="avatar-uploader"
                                        :http-request="uploadFun"
                                        :auto-upload="false"
                                        action="https://api.retailstore365.com:15041/uploadphoto"
                                        :on-change="handChange"
                                        :before-upload="beforePhotoUpload"
                                        :show-file-list="false">
                                    <img v-if="dialogImageUrl" :src="dialogImageUrl" class="avatar">
                                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <span :class="$style.desc">您可以上传jpg或png格式的文件, 文件大小不能超过10M。</span>
                            </div>


                        </el-form-item>

                    </el-form>
                </div>

            </div>

        </el-dialog>
    </div>

</template>

<script>
    import Pagination from '../../../components/pagination'
    import http from '../../../APIService/http'

    import Pic_icon from '../../../assets/images/pic_icon.png'
    import Add_picture from '../../../assets/images/add_picture.png'
    import Delete_icon from '../../../assets/images/delete_icon.png'

    export default {
        data() {
            return {
                loading: false,
                isAdmin: false,
                store_id: '',
                photosArray: [],
                dialogVisible: false,
                dialogVisiblePhoto: false,
                dialogSrc: '',
                dialogImageUrl: '',
                Add_picture: Add_picture,
                Delete_icon: Delete_icon,


                title: '',
                isUpload: false
            }
        },
        created() {
            let user = this.$store.getters.getUser
            if(user.role === 'admin'){
                this.isAdmin = true
            }

            let storeInfoObj = this.$store.getters.getStore
            this.store_id = storeInfoObj.id
            if (this.store_id) {
                this.initInfo()
            }
        },
        components: {},
        computed: {
            libraryId() {
                return true
            }
        },
        methods: {

            async initInfo() {
                try {

                    this.loading = true

                    var user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        store_id: this.store_id
                    }
                    await http.post('/wapi/v1/getStore_photo', data).then(res => {

                        this.photosArray = res.data

                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }
            },
            async getImgUrl(photoItem, id) {
                try {

                    if (photoItem.photoUrl) {
                        return
                    }

                    let data = {
                        reference_obj: 'INSTITUTION',
                        reference_id: 'com.saasyun.android',
                        credential: '58f09f86-694c-472d-bb63-64f9be093fd2',
                        photo_ids: id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    // let res = await http.post('/downloadphoto/downloadphotos', data)
                    let res = await http.post('https://api.retailstore365.com:15041/downloadphotos', data)
                    let array = res.data

                    if (array.length > 0) {


                        photoItem.photoUrl = array[0].thu_url
                        photoItem.bigPhotoUrl = array[0].url

                        this.$forceUpdate()
                    }

                } catch (err) {
                    console.log(`error:${err}`)
                }
            },
            async deletePhotos(photo_id) {

                try {
                    this.loading = true
                    let data = {
                        photo_id: photo_id,
                        store_id: this.store_id,
                        tenant_id: this.$store.getters.getUser.tenant_id
                    }

                    await http.post('/wapi/v1/delStore_photo', data).then(res => {

                        this.initInfo()

                        this.loading = false
                    })
                } catch (err) {
                    this.loading = false
                    this.error()
                }

            },
            dialogVisibles(photoUrl) {

                this.dialogSrc = photoUrl
                this.dialogVisible = true
            },
            showDialogVisiblesPhoto() {

                this.dialogVisiblePhoto = true

            },
            showPhoto(url) {
                if (!url) {
                    return Pic_icon
                } else {
                    return url
                }

            },
            uploadFun(param) {



                var data = new FormData(); //创建form对象
                data.append('file', param.file);
                data.append('reference_obj', 'CLIENT');
                data.append('reference_id', 'com.saasyun.android');
                data.append('credential', '58f09f86-694c-472d-bb63-64f9be093fd2');
                data.append('username', this.$store.getters.getUser.username);
                data.append('tenant_id', this.$store.getters.getUser.tenant_id);
                data.append('user_id', this.$store.getters.getUser.user_id);
                data.append('category', 'USER');
                data.append('size', '300');
                // data.append('bucket','retaium-file');
                // data.append('category','LIBRARY');


                var config = {
                    headers: {'Content-Type': 'multipart/form-data'}
                };  //添加请求头
                http.post(param.action, data, config)//
                    .then(response => {

                        if (response.success) {

                            //如果是编辑并换了文件

                            this.savaFileId(response.data.s3filename)

                        }
                    })
                    .catch(({err}) => {

                        this.loading = false
                    })
            },
            submitFile() {

                if (!this.title) {
                    this.$message({message: '请输入标题', type: 'error'});
                    return
                }

                if (!this.isUpload) {
                    this.$message({message: '请选择图片', type: 'error'});
                    return
                }

                this.loading = true

                this.$refs.uploadFile.submit()

            },
            async savaFileId(photo_id) {

                let userObj = this.$store.getters.getUser

                let data = {
                    tenant_id: userObj.tenant_id,
                    store_id: this.store_id,
                    photo_id:photo_id,
                    title:this.title,
                    sort:this.photosArray.length + 1,
                    created_by:userObj.user_id
                }

                await http.post('/wapi/v1/saveStorePhoto', data).then(res => {

                    let success  = res.success

                    if(success){
                        this.dialogVisiblePhoto = false
                        this.isUpload = false
                        this.title = ''
                        this.dialogImageUrl = ''

                        this.$message({ message: '上传成功!', type: 'success' });
                        this.initInfo()
                    }

                    this.loading = false


                })
            },
            handChange(file) {
                this.isUpload = true
                let fileName = file.name;
                let regex = /(.jpg|.jpeg|.png)$/;
                if (regex.test(fileName.toLowerCase())) {
                    this.dialogImageUrl = URL.createObjectURL(file.raw);
                } else {
                    this.$message.error('请选择图片文件');
                }
            },
            // 图片上传前的验证
            beforePhotoUpload(file) {

                const fileSize = file.size / 1024 / 1024 < 10 * 1.2

                if (!fileSize) {
                    this.error('上传的图片大小不能超过10MB!')
                    return false
                }

                return true
            },

            handleClose(done) {

                this.dialogVisiblePhoto = false
//                this.$confirm('确认关闭？')
//                    .then(_ => {
                done();
//                    })
//                    .catch(_ => {});
            }

        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        .desc {
            font-size: $fontSize;
            color: #9b9b9b;
            text-align: left;
            margin: 0px;
        }
    }
</style>
<style scoped>

    .upload >>> .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .upload >>> .el-upload:hover {
        border-color: #409EFF;
    }

    .upload >>> .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }

    .upload >>> .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }

    .wrap {
        display: inline-block;
    }

    .desc {
        font-size: 14px;
        color: #9b9b9b;
        width: 120px;
        text-align: center;
        margin: 0;
    }

</style>




// WEBPACK FOOTER //
// src/pages/stores/photos/index.vue